<template>
  <div class="mb-sm grid grid-cols-2 gap-sm">
    <ArendeProperty label="Kanal" data-testid="closed-arende-kanal">{{
      arendeStore.arende.data?.kanal
        ? KanalTypeLabels[arendeStore.arende.data?.kanal]
        : "Övrigt"
    }}</ArendeProperty>
    <ArendeProperty label="Kundgrupp" data-testid="closed-arende-kundgrupp">
      {{ arendeStore.arende.data?.kundgrupp }}
    </ArendeProperty>
    <ArendeProperty
      label="Överlämnad till"
      data-testid="closed-arende-overlamnad-till"
      >{{ arendeStore.arende.data?.overlamnadTill }}</ArendeProperty
    >
    <ArendeProperty
      label="Kunds e-postadress"
      data-testid="closed-arende-epost"
    >
      {{ individStore.individ.data?.email }}
    </ArendeProperty>
    <ArendeProperty
      label="Kunds telefonnummer"
      data-testid="closed-arende-telefonnummer"
    >
      {{ individStore.individ.data?.telefonnummer }}
    </ArendeProperty>
    <ArendeProperty label="Ärendetyp" data-testid="closed-arende-arendetyp">{{
      arendeStore.arende.data?.arendetyp
    }}</ArendeProperty>
    <ArendeProperty label="Ombud" data-testid="closed-arende-ombud">{{
      arendeStore.arende.data?.ombud ? "Ja" : "Nej"
    }}</ArendeProperty>
  </div>
  <ArendeProperty label="Kopiera länk till ärendet">
    <CopyToClipboard
      v-if="arendeStore.arende.data?.id"
      text="Klicka här för att kopiera ärendelänk"
      :data="composeAnstalldarendeUrl(arendeStore.arende.data.id)"
    />
  </ArendeProperty>
</template>

<script setup lang="ts">
import { KanalTypeLabels } from "@/common/constants";
import { composeAnstalldarendeUrl } from "@/common/utils/composeAnstalldArendeUrl";
import ArendeProperty from "@/components/arende-components/ArendeProperty.vue";
import CopyToClipboard from "@/components/ui/CopyToClipboard.vue";
import { useIndividStore } from "@/stores";

import { useAnstalldarendeStore } from "../../store";

const individStore = useIndividStore();
const arendeStore = useAnstalldarendeStore();
</script>
